import { forwardRef } from 'react';

import { ArrowLeft } from '@phosphor-icons/react';
import classnames from 'classnames';

import { TooltipWrapper } from '@/ui/TooltipWrapper';

import * as styles from '../PostActions.css';
export interface BackButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
}

const BackButton = forwardRef<HTMLButtonElement, BackButtonProps>(({ onClick, className, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={classnames('flex justify-center', styles.button, className)}
      onClick={onClick}
      {...props}
    >
      <ArrowLeft size={20} />
    </button>
  );
});

BackButton.displayName = 'BackActionButton';

interface BackActionButtonProps extends BackButtonProps {
  translations?: Record<string, string>;
}

export const BackActionButton = ({ onClick, translations, ...props }: BackActionButtonProps) => {
  const label = translations?.['search.pagination.back'];

  if (label) {
    return (
      <TooltipWrapper portalId="post-actions-container" tooltipText={label}>
        <BackButton onClick={onClick} {...props} aria-label={label} />
      </TooltipWrapper>
    );
  }

  return <BackButton onClick={onClick} {...props} />;
};
